module.exports = __webpack_public_path__ + "img/obs_snow_missing.368abae3.svg";